<template>
  <div
    v-if="!isLoading"
    :id="pageNavigationIds.GIFT_DETAIL"
    class="gift-detail-area"
  >
    <div class="gift-detail-area__content">
      <DecorationHead text="ギフト詳細" :heading-level="2" />
      <ItemDescriptionArea
        v-if="hasDescriptionItems"
        class="gift-detail-area__content-body"
        :description-items="descriptionItems"
        :mail-slot-deliverable="mailSlotDeliverable"
      />
      <KittyHtmlSanitized
        v-else
        additional-class="gift-detail-area__content-body"
        :html="descriptionHtml"
      />
      <StaffReviewArea
        v-if="hasStaffReviews"
        class="gift-detail-area__content-body"
        :staff-reviews="staffReviews"
      />
    </div>
  </div>
</template>

<script>
import DecorationHead from '../../atoms/decoration/DecorationHead.vue'
import ItemDescriptionArea from './ItemDescriptionArea.vue'
import KittyHtmlSanitized from '../../atoms/html/KittyHtmlSanitized.vue'
import StaffReviewArea from './StaffReviewArea.vue'
import { pageNavigationIds } from '../../../constants/pageNavigationConstants'

export default {
  name: 'GiftDetailArea',
  components: {
    DecorationHead,
    ItemDescriptionArea,
    KittyHtmlSanitized,
    StaffReviewArea
  },
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    descriptionItems: {
      type: Array,
      required: false,
      default: () => []
    },
    mailSlotDeliverable: {
      type: Boolean,
      required: false,
      default: false
    },
    descriptionHtml: {
      type: String,
      required: false,
      default: ''
    },
    staffReviews: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      pageNavigationIds
    }
  },
  computed: {
    hasDescriptionItems() {
      return this.descriptionItems && this.descriptionItems.length > 0
    },
    hasStaffReviews() {
      return this.staffReviews && this.staffReviews.length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.gift-detail-area {
  margin: 16px auto 0 auto;
  background-color: $white;
  text-align: left;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 32px;
    margin: 0 auto;
    max-width: $base-contents-width;
  }

  &__content-body {
    margin: auto;
    max-width: 720px;
    width: 100%;
    width: -moz-available;
    width: -webkit-fill-available;
    width: stretch;

    @media all and (max-width: $base-contents-width - 1) {
      padding: 0 16px;
    }

    :deep(*) {
      box-sizing: border-box;
    }
  }
}
</style>
